export default function notFound({ next, store }) {
  if (store.getters.isAuth) {
    const step = store.getters['register/registrationStep'];
    if (step) {
      return next({
        name: step,
      });
    }
  }
  return next({
    name: 'login',
  });
}

